import { fetchM } from './fetchM';
import { rejectionFromResponse, rejectionFor } from '../utils/crmLink';

// The reason is in the response BODY for this endpoint, so reading it is asynchronous and can
// itself fail — an empty body, a proxy's HTML error page. A body we cannot parse is not a reason
// to lose the rejection: the status still says something useful.
function rejectionFromBody(res) {
  const fromStatus = () => ({ rejection: rejectionFromResponse(res, null) });
  if (!res || typeof res.json !== 'function') return Promise.resolve(fromStatus());
  return res.json()
    .then(body => ({ rejection: rejectionFromResponse(res, body) }))
    .catch(fromStatus);
}

// Reading a CRM link session (MS-6620, T4.6).
//
// `GET /crm/links/<id>/` is the only place the buyer's details are fetched, and the read is what
// binds the session to whoever opened it — so it happens after login, from the SPA, and never
// before. The response never goes into a URL.
//
// `ignoreNotFound` and `returnForbidden` are set because both statuses are part of this endpoint's
// contract rather than a wrong turn: a session that has been consumed, expired, or was opened by a
// colleague is something to explain on the page with its reference id, not a bounce to the generic
// forbidden or not-found screen where that reference is lost.
export function loadCRMLinkSession(id) {
  return dispatch => dispatch(fetchM(`/crm/links/${encodeURIComponent(id)}/`, {
    credentials: 'include',
    ignoreNotFound: true,
    returnForbidden: true,
  }))
    .then((res) => {
      // With those two flags a rejection can arrive as a resolved response that is simply not ok,
      // so the status is checked here rather than relying on a thrown error.
      if (!res || !res.ok) return rejectionFromBody(res);
      return res.json().then(session => ({ session }));
    })
    .catch((err) => {
      // A FetchError carries the response it failed on; anything else is the network or a bug, and
      // both are "we could not read it, try again".
      const res = err && err.res;
      if (!res) return { rejection: rejectionFor('unavailable', '') };
      return rejectionFromBody(res);
    });
}

export default loadCRMLinkSession;



// WEBPACK FOOTER //
// ./src/actions/crmLink.js